import { Component, Output, ViewChild, EventEmitter, AfterViewChecked, Input, OnChanges } from '@angular/core';
import { MemberService } from "../services/member.service";
const alertify = require("alertify.js");

declare var jQuery: any;

@Component({
  selector: 'ch-member-delete-dialog',
  templateUrl: './member-delete-dialog.component.html',
  styleUrls: ['./member-delete-dialog.component.css'],
})
export class MemberDeleteDialogComponent implements OnChanges, AfterViewChecked {
  @Input() public show: boolean;
  @Input() public memberId: string;
  @Output() public onClose: EventEmitter<any> = new EventEmitter();
  @ViewChild('modal') private modal;
  private change: boolean;
  public loading = false;
  public gdprDelete = false;

  constructor(private service: MemberService) { }

  ngOnInit() {
    alertify.logPosition("bottom right");
  }

  ngOnChanges() {
    if (this.show) {
      this.change = true;
    }
  }

  ngAfterViewChecked() {
    if (this.change) {
      jQuery(this.modal.nativeElement)
        .modal({
          backdrop: false,
        })
        .on('hidden.bs.modal', e => {
          this.onClose.emit(e);
        });

      this.change = false;
    }
  }

  confirm() {
    this.loading = true;
    this.service.deleteMember(this.memberId, this.gdprDelete).subscribe(
      resp => {
        this.loading = false;
        alertify.success("Member deleted successfully");
        jQuery(this.modal.nativeElement).modal('hide');
      },
      error => {
        this.loading = false;
        this.alertError(error);
      }
    );
  }

  private alertError(error: any) {
    if (!error.error) {
      alertify.error(`There was a ${error.status} error with the request.`);
    } else {
      alertify.error(
        `There was a ${error.status} error with message '${error.error}'.`
      );
    }
  }
}




// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/member/member-delete-dialog/member-delete-dialog.component.ts